// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"115ec10a","621":"381a9715","743":"a6bf4f9a"}[chunkId] + ".chunk.js";
};